import { QLoginManager, DeviceInfo } from 'qunar-react-native';
import getQueryParam from '../Utils/getQueryParam';
// import LoginManager from './LoginManager';

const { isMini, isWeb } = DeviceInfo;

// 正在登录中
// global.isLogining = false;

const isLogin = () => {
    if (isWeb && getQueryParam('fromChannel')) {
        return true;
    }
    if (DeviceInfo?.platform?.toUpperCase() === 'WECHAT') {
        if (__wxConfig.envVersion === "develop") {
            return true;
        }
    }
    return new Promise((resolve) => {
        QLoginManager.getLoginInfo(
            (userData) => {
                const { userIsValid } = userData;
                const hasLogin = userData && Boolean(Number(userIsValid));
                resolve(Boolean(hasLogin));
            },
            () => {
                resolve(false);
            }
        );
    });
}
    

const getUserInfo = () =>
    new Promise((resolve) => {
        QLoginManager.getLoginInfo(
            (userData) => {
                resolve(userData);
            },
            () => {
                resolve({});
            }
        );
    });

const loginParam = {
    extData: {
        usersource: 'mobile_ucenter',
        origin: 'order_list'
    }
};

const login = () =>
    new Promise((resolve) => {
        // isLogining = true;
        // LoginManager.isLogining = true;
        QLoginManager.loginWithParam(
            loginParam,
            (data) => {
                // TODO: fix
                if(isMini){
                    resolve(data || true);
                }else{
                    resolve(data);
                }
                
            },
            () => {
                resolve(false);
            }
        );
    });

// 全局的延时登录回调
// global.$loginSucCb = null;
// 延时计时器
// global.$goLoginTimer = null;

// 延时登录是全局节流的
// const delayLogin = () => {
//     // if (!$goLoginTimer) {
//     if (!LoginManager.goLoginTimer) {
//         // 重置全局的延时登录回调
//         // $loginSucCb = null;
//         LoginManager.loginSucCb = null;
//         // 延时计时器
//         // $goLoginTimer = setTimeout(async () => {
//         LoginManager.goLoginTimer = setTimeout(async () => {
//             // const hasLogined = (await isLogin());

//             // if (isLogining || hasLogined) {
//             // TODO 正常需要在计时器到时之后，先看看用户是否在3秒内已经登录了
//             // 但是qrn的loginManager在登录态被踢对的情况下，依然会返回用户已登录
//             // 所以这个就依赖架构组把这个修复好
//             // if (isLogining) {
//             //     $goLoginTimer && clearTimeout($goLoginTimer);
//             //     $goLoginTimer = null;
//             //     return;
//             // }
//             if (LoginManager.isLogining) {
//                 LoginManager.goLoginTimer && clearTimeout(LoginManager.goLoginTimer);
//                 LoginManager.goLoginTimer = null;
//                 return;
//             }
//             let userIsLogin;

//             try {
//                 userIsLogin = await login();
//             } catch (err) {
//                 userIsLogin = false;
//             }

//             // $goLoginTimer && clearTimeout($goLoginTimer);
//             // $goLoginTimer = null;
//             LoginManager.goLoginTimer && clearTimeout(LoginManager.goLoginTimer);
//             LoginManager.goLoginTimer = null;

//             // if (userIsLogin) {
//             //     $loginSucCb && $loginSucCb(userIsLogin);
//             // }
//             if (userIsLogin) {
//                 LoginManager.loginSucCb && LoginManager.loginSucCb(userIsLogin);
//             }

//             // $loginSucCb = null;
//             LoginManager.loginSucCb = null;
//         }, 3000);
//     }
// };

// export { isLogin, login, delayLogin, getUserInfo };
export { isLogin, login, getUserInfo };